const DEFAULT_API_BASE_URL = "https://dev.stenograph.mozaik.tech/api/v1";

const normalizeApiBaseUrl = (url: string): string => url.replace(/\/+$/, '');

export const getApiBaseUrl = (): string => {
  return normalizeApiBaseUrl(
    process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL
  );
};
